import { Link } from "react-router-dom";
import { BookOpen, ArrowRight } from "lucide-react";

export const GuidesGrid = ({ guides }) => {
  if (!guides?.length) return null;
  return (
    <section className="mb-20 scroll-mt-28" id="guides" data-testid="guides-section">
      <div className="flex items-center gap-3 mb-3">
        <BookOpen className="w-5 h-5 text-[#8C7B6B]" />
        <h2 className="font-display text-base sm:text-lg uppercase tracking-wide text-[#1A1A1A]">Peptide Research Guides</h2>
        <div className="flex-1 h-px bg-[#DDD7CF]" />
        <span className="text-xs text-[#6E675F] shrink-0" data-testid="guides-count">{guides.length} guide{guides.length === 1 ? "" : "s"}</span>
      </div>
      <p className="text-sm text-[#6E675F] max-w-2xl mb-8">
        Citation-backed reference guides on each peptide we carry — what it is, what it is being studied for, how it is thought to work and where the evidence stands. Written by the Eternal Biolabs Research Desk. No dosing or usage guidance.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-testid="guides-grid">
        {guides.map((g) => (
          <Link
            key={g.slug}
            to={`/guides/${g.slug}`}
            data-testid={`guide-card-${g.slug}`}
            className="group border border-[#DDD7CF] rounded-lg bg-white p-5 sm:p-6 flex flex-col hover:border-[#8C7B6B] hover:-translate-y-0.5 transition-[border-color,transform] duration-200"
          >
            <div className="flex items-center gap-2">
              <span className="inline-flex text-[10px] tracking-[0.1em] uppercase font-bold bg-[#EFEBE6] text-[#8C7B6B] rounded-none px-2.5 py-1">{g.category}</span>
              {g.product_count > 0 && <span className="text-[11px] text-[#6E675F] ml-auto">{g.product_count} product{g.product_count === 1 ? "" : "s"}</span>}
            </div>
            <h3 className="font-display text-sm uppercase tracking-wide text-[#1A1A1A] mt-4">{g.peptide}</h3>
            <p className="text-sm text-[#6E675F] mt-2 leading-relaxed flex-1 line-clamp-4">{g.quick_answer}</p>
            <span className="mt-4 inline-flex items-center gap-1.5 text-xs tracking-[0.15em] uppercase font-semibold text-[#8C7B6B] group-hover:text-[#75665A] transition-colors">
              Read the guide <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
};
